import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import Icon from 'flarum/common/components/Icon';
export default class Widget extends Component {
  view() {
    return m("div", {
      className: classList(['FofWidgets-Widget', this.className()])
    }, this.header(), m("div", {
      className: "FofWidgets-Widget-content"
    }, this.content()));
  }
  header() {
    const iconName = this.icon();
    const title = this.title();
    return title ? m("div", {
      className: "FofWidgets-Widget-title"
    }, iconName ? m("span", {
      className: "FofWidgets-Widget-title-icon"
    }, m(Icon, {
      name: iconName
    })) : null, m("span", {
      className: "FofWidgets-Widget-title-label"
    }, title), m("div", {
      className: "FofWidgets-Widget-title-desc"
    }, this.description())) : null;
  }
  className() {
    return '';
  }
  title() {
    return '';
  }
  description() {
    return '';
  }
  icon() {
    return '';
  }
  content() {
    return '';
  }
}
flarum.reg.add('fof-forum-widgets-core', 'common/components/Widget', Widget);